/*
 * @Author: Kenneth Michael 3366392382@qq.com
 * @Date: 2023-12-01 18:42:38
 * @LastEditors: Kenneth Michael 3366392382@qq.com
 * @LastEditTime: 2024-02-19 22:14:58
 * @FilePath: \NEW_SANKUANZ03\assets\main-collection-product-grid.js
 * @Description:
 *
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved.
 */

var filterHeight = 0;
var filterData = [];

document.addEventListener("DOMContentLoaded", ()=> {
    const filter_btn = document.querySelector("#filter_btn");
    const close_sort_btn = document.querySelector("#close_sort_btn");

    function changeFilterStatus() {
        const filtersContainer = document.querySelector(".filters-container");
        const main_collection_product = document.querySelector("#main_collection_product");
        const height = filtersContainer.clientHeight;
        // 获取页面滚动高度
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;

        filterHeight = height;

        if (scrollTop === 0) {
            document.documentElement.style.setProperty('--self-adaption-top', `${height}px`);
        } else {
            // 获取--header-height的值
            var headerHeight = document.documentElement.style.getPropertyValue("--header-height");
            document.documentElement.style.setProperty('--self-adaption-top', headerHeight);
        }
        main_collection_product.classList.toggle('self-adaption-top');

        const sort_by_items = document.querySelectorAll("#sort_by_item");

        sort_by_items.forEach((item) => {
            item.addEventListener("click", (event) => {
                // 阻止默认行为，即阻止链接的跳转
                event.preventDefault();
                // 获取item节点中的data-value属性值
                const dataValue = item.getAttribute("data-sort_by");
                const searchParams = `sort_by=${dataValue}`;
                history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);

                const url = `${window.location.pathname}?${searchParams}`;
                renderSectionFromFetch(url, event);

                const filter_list_lis = document.querySelector("#filter_list").querySelectorAll("li");

                const filter_actives = document.querySelectorAll(".filter_active");
                filter_actives.forEach((item) => {
                    item.classList.remove("filter_active");
                })

                // // 获取父级节点
                const parent = item.parentNode;
                parent.classList.add("filter_active");
            });
        });

        const clearBtns = document.querySelectorAll("#clearbtn");
        clearBtns.forEach((item) => {
            item.addEventListener("click", (event) => {
                event.preventDefault();
                const searchParams = ``;
                history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
                const url = window.location.pathname;
                console.log('url', url);
                renderSectionFromFetch(url, event);
                const filter_actives = document.querySelectorAll(".filter_active");
                filter_actives.forEach((item) => {
                    item.classList.remove("filter_active");
                })
            });
        })
    }

    if (filter_btn) {
        filter_btn.addEventListener("click", () => changeFilterStatus());
    }

    if (close_sort_btn) {
        close_sort_btn.addEventListener("click", () => changeFilterStatus());
    }

    function renderSectionFromFetch(url, event) {

        fetch(url)
            .then((response) => response.text())
            .then((responseText) => {
                const html = responseText;
                // filterData = [...filterData, { html, url }];
                renderProductGridContainer(html);
                if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);


            });
    }

    function renderProductGridContainer(html) {
        document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;

        document
            .getElementById('ProductGridContainer')
            .querySelectorAll('.scroll-trigger')
            .forEach((element) => {
                // element.classList.add('scroll-trigger--cancel');
            });
    }
})


document.addEventListener("scroll", (event)=> {
    // console.log('页面滚动', event);
    var headerHeight = document.documentElement.style.getPropertyValue("--header-height");
    headerHeight = parseFloat(headerHeight);
    // 获取页面距离顶部的高度
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    if (headerHeight < filterHeight && scrollTop <= 10) {
        let num = filterHeight - headerHeight;
        document.documentElement.style.setProperty('--self-adaption-top', `${filterHeight}px`);
    }
});
